// extracted by mini-css-extract-plugin
export default {"section-disabled":"styles_section-disabled__2C5Vd","sectionDisabled":"styles_section-disabled__2C5Vd"};